import {useState, useEffect} from 'react'
import { FaAngleDoubleUp } from "react-icons/fa";
const TopButton = () => {
    const [showTopButton, setShowTopButton] = useState(false);
    const scrollToTop =  () => {
        window.scrollTo(
            {
                top: 0,
                behavior: 'smooth',
            }
        )
    }

    const handleScroll = () => { 
        if (window.scrollY > 250)
            setShowTopButton(true);
        else
        setShowTopButton(false);
    }
    
    useEffect(() => {
        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    return (
        <div>
        {showTopButton && <FaAngleDoubleUp className="scroll-btn-top" onClick={scrollToTop}/>}
        </div>
    )
}

export default TopButton
